import { useSafeState, useSize } from "ahooks";
import { Radio } from "antd";
import classNames from "classnames";
import { useCallback, useEffect, useRef, useState } from "react";
import styles from "./index.module.less";

export default function HBTabButton({
  // options: _options = [],
  options = [],
  value: _value,
  className = "",
  onChange,
  optionClass = {},
  style = {},
  size = null,
  renderType = "default",
}) {
  const listRef = useRef(null);
  const [value, setValue] = useState(_value);
  const [bgStyle, setBgStyle] = useSafeState();
  // const [options, setOptions] = useState(_options);
  const activeSize = useSize(() => listRef.current?.querySelector(".active"));

  const calculateBgStyle = useCallback(() => {
    const el = listRef.current?.querySelector(".active");
    setBgStyle(
      el
        ? {
            width: `${el.offsetWidth}px`,
            left: `${el.offsetLeft}px`,
          }
        : null
    );
  }, [setBgStyle]);

  const onClick = useCallback(
    (evt, option) => {
      if (evt.ctrlKey || evt.metaKey) {
        return;
      }

      evt.preventDefault();
      onChange && onChange(option, option.value);
      setValue(option.value);
    },
    [onChange]
  );

  useEffect(() => {
    setValue(_value);
    // 异步是因为需要等待ui更新了才能获取到正确的状态
    setTimeout(() => {
      calculateBgStyle();
    }, 1);

    const onLoad = () => {
      calculateBgStyle();
    };

    window.addEventListener("load", onLoad);

    return () => {
      window.removeEventListener("load", onLoad);
    };
  }, [_value, calculateBgStyle, activeSize]);

  // useEffect(() => {
  //   const option = _options.find((option) => option.value === value);
  //   if (option?.firstClickKey) {
  //     localStorage.setItem(option.firstClickKey, true);
  //     dispatch({ type: "setSucaiIsRead", payload: true });
  //   }
  //   setOptions(
  //     _options.map((option) => {
  //       return {
  //         ...option,
  //         dot:
  //           option.firstClickKey && !localStorage.getItem(option.firstClickKey),
  //       };
  //     })
  //   );
  // }, [_options, dispatch, value]);

  // 渲染默认样式的选项
  const renderDefaultOption = () => (
    <div
      className={classNames([
        styles.button,
        className,
        size === "small" ? styles.small : null,
      ])}
      style={style}
    >
      <div className={classNames([styles.bg, "bg"])} style={bgStyle} />
      <div className={styles.list} ref={listRef} data-value={value}>
        {options.map((option) => (
          <a
            data-value={option.value}
            key={option.value}
            className={classNames([
              styles.item,
              option.dot ? styles.dot : null,
              value === option.value ? "active" : null,
              optionClass[option.value] || null,
            ])}
            onClick={(evt) => onClick(evt, option)}
            style={
              value === option.value
                ? {
                    color: "#1E2023",
                    ...(option.style || {}),
                  }
                : { ...(option.style || {}) }
            }
            {...(option.href ? { href: option.href } : null)}
            {...(option.target ? { target: option.target } : null)}
            {...(option.trackerProps || null)}
          >
            {option.name}
          </a>
        ))}
      </div>
    </div>
  );

  // 渲染Radio样式的选项
  const renderRadioOption = () => (
    <div
      className={classNames([styles.radioContainer, className])}
      style={style}
    >
      <Radio.Group
        value={value}
        onChange={(e) => {
          const option = options.find((opt) => opt.value === e.target.value);
          onChange && onChange(option, option.value);
          setValue(option.value);
        }}
        className={styles.radioGroup}
      >
        {options.map((option) => (
          <Radio
            key={option.value}
            value={option.value}
            className={styles.radio}
            {...(option.trackerProps || null)}
          >
            <span className={styles.radioLabel}>{option.name}</span>
          </Radio>
        ))}
      </Radio.Group>
    </div>
  );

  if (renderType === "radio") {
    return renderRadioOption();
  }

  return renderDefaultOption();
}
